<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="loading-wrapper">
      <div class="ring-loading">
        <div class="k-ring k-ring-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalMask from '@/components/modal/ModalMask'

export default {
name: 'LoadingShow',

components: { ModalMask },
props: {

},
data () {
  return {
    showing: false
  }
},
methods: {
  close () {
    this.showing = false
  },
  show () {
    this.showing = true
  }
},
filter: {

},
computed: {

},
watch: {

}
}
</script>

<style scoped lang="less">
@import '../../style/mixin';

.loading-wrapper {
  background: #292C38;
  width: 10rem;
  height: 10rem;
  .modal-common;
  /* .modal-anim; */
}
@keyframes ring-loading {
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ring-loading {
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.k-ring-1 {
  animation: ring-loading 1s linear 0s infinite;
}
.k-ring {
  width: .5rem;
  height: .5rem;
  margin: auto;
  padding: 1.2rem;
  border-radius: 50%;
  border: .2rem solid #00D176;
  border-right: .2rem solid rgba(53,203,155, 0.1);
}
</style>
